(function () {
  if (window.WiperShopVehicleDisplay) return;

  function value(input) {
    return String(input || '').trim();
  }

  function cleanSpaces(input) {
    return value(input).replace(/\s+/g, ' ');
  }

  function getRegistrationVehicleName(vehicle) {
    vehicle = vehicle || {};

    return cleanSpaces(
      vehicle.fullModel ||
      vehicle.displayName ||
      [vehicle.make, vehicle.model, vehicle.bodyStyle].filter(Boolean).join(' ')
    );
  }

  function getRegistrationVehicleMeta(vehicle) {
    vehicle = vehicle || {};
    const bits = [];

    if (vehicle.year) bits.push(value(vehicle.year));
    if (vehicle.bodyStyle) bits.push(value(vehicle.bodyStyle));

    return bits.join(' • ');
  }

  function getCatalogueGeneration(row) {
    row = row || {};
    const raw = cleanSpaces(row.variant || row.chassis || '');
    if (!raw) return '';

    const upper = raw.toUpperCase();

    // A clean generation already stored in the catalogue, e.g. I, II, III, IV.
    if (/^(?:I|II|III|IV|V|VI|VII|VIII|IX|X)$/.test(upper)) {
      return upper;
    }

    // Some supplier variants join the generation to the body description,
    // e.g. IIITURNIER or IIITURNIER, DA. Keep the generation for display,
    // while leaving the full raw variant untouched for fitment matching.
    const bodyWords =
      '(?:TURNIER|ESTATE|SALOON|SEDAN|HATCHBACK|HATCH|SUV|COUPE|CABRIOLET|CONVERTIBLE|ROADSTER|VAN|MPV|WAGON|TOURING|AVANT|SPORTWAGON|LIFTBACK)';

    const joined = upper.match(
      new RegExp(
        '^(I|II|III|IV|V|VI|VII|VIII|IX|X)' +
        bodyWords +
        '(?:\\b|[,;])'
      )
    );

    if (joined) return joined[1];

    const separated = upper.match(
      /^(I|II|III|IV|V|VI|VII|VIII|IX|X)(?:\s|[,;\-/])/
    );

    if (separated) return separated[1];

    return '';
  }

  function getCatalogueVehicleName(row, fallback) {
    row = row || {};
    fallback = fallback || {};

    const make = value(row.make || fallback.make);
    const model = value(row.model_display || fallback.model);
    const generation = getCatalogueGeneration(row);

    return [make, model, generation].filter(Boolean).join(' ');
  }

  function getCatalogueBody(row, fallback) {
    row = row || {};
    fallback = fallback || {};

    return value(row.vehicle_type || fallback.type);
  }

  window.WiperShopVehicleDisplay = {
    getRegistrationVehicleName: getRegistrationVehicleName,
    getRegistrationVehicleMeta: getRegistrationVehicleMeta,
    getCatalogueGeneration: getCatalogueGeneration,
    getCatalogueVehicleName: getCatalogueVehicleName,
    getCatalogueBody: getCatalogueBody
  };
})();